/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsLocaleStringListItem,
    ControlcenterMelcoModelsLocaleStringListItemFromJSON,
    ControlcenterMelcoModelsLocaleStringListItemFromJSONTyped,
    ControlcenterMelcoModelsLocaleStringListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsLocaleStringListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    list: Array<ControlcenterMelcoModelsLocaleStringListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    return ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsLocaleStringListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsLocaleStringListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


